var map = {
	"./SAINT_3121.jpg": 674,
	"./SAINT_4532.jpg": 675,
	"./SAINT_6022.jpg": 676,
	"./SAINT_6620.jpg": 677,
	"./SAINT_6943.jpg": 678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 673;